import { render } from "./AppComingSoonSection.vue?vue&type=template&id=7d3c1bb6&scoped=true"
import script from "./AppComingSoonSection.vue?vue&type=script&lang=js"
export * from "./AppComingSoonSection.vue?vue&type=script&lang=js"

import "./AppComingSoonSection.vue?vue&type=style&index=0&id=7d3c1bb6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d3c1bb6"]])

export default __exports__